import { render, staticRenderFns } from "./PatientTimeline.vue?vue&type=template&id=87919f86&scoped=true"
import script from "./PatientTimeline.vue?vue&type=script&lang=js"
export * from "./PatientTimeline.vue?vue&type=script&lang=js"
import style0 from "./PatientTimeline.vue?vue&type=style&index=0&id=87919f86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87919f86",
  null
  
)

export default component.exports